module.exports = __webpack_public_path__ + "img/icon13.a54dc8ad.png";